import RecommendedText from './RecommendedText';
export default RecommendedText;